<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { type ReviewApiUser, reviewApiUsersApi } from '@/api/entities/admin/reviewApiUsers'

definePage({
  meta: { title: 'Review API Users', action: 'read', subject: 'review' },
})

const { snackbar, handleError } = useErrorHandler()
const loading = ref(false)
const refreshing = ref(false)
const users = ref<ReviewApiUser[]>([])

const headers = [
  { title: 'ID', key: 'id', sortable: false },
  { title: 'Client', key: 'client', sortable: false },
  { title: 'Client ID', key: 'client_id', sortable: false },
  { title: 'Password', key: 'client_password', sortable: false },
  { title: 'Authorization', key: 'authorization', sortable: false },
]

const loadUsers = async () => {
  loading.value = true
  try {
    const { success, data } = await reviewApiUsersApi.list()
    if (success && data) users.value = data
  }
  catch (error) {
    handleError(error, { showNotification: false })
  }
  finally {
    loading.value = false
  }
}

const handleRefreshCremaToken = async () => {
  refreshing.value = true
  try {
    const { success, error } = await reviewApiUsersApi.refreshCremaToken()
    if (success) {
      snackbar.success('크레마 토큰이 갱신되었습니다.')
      await loadUsers()
    }
    else {
      snackbar.error(error?.message || '토큰 갱신 실패')
    }
  }
  catch (error) {
    handleError(error)
  }
  finally {
    refreshing.value = false
  }
}

onMounted(loadUsers)
</script>

<template>
  <VCard>
    <VCardTitle class="pa-4 d-flex align-center justify-space-between">
      Review API Users
      <VBtn
        color="warning"
        :loading="refreshing"
        @click="handleRefreshCremaToken"
      >
        크레마 토큰 갱신
      </VBtn>
    </VCardTitle>
    <VCardText>
      <VDataTable
        :headers="headers"
        :items="users"
        :loading="loading"
        hide-default-footer
      >
        <template #no-data>
          <div class="text-center py-8">
            데이터가 없습니다.
          </div>
        </template>
      </VDataTable>
    </VCardText>
  </VCard>
  <VSnackbar
    v-model="snackbar.isVisible.value"
    :color="snackbar.color.value"
    :timeout="snackbar.timeout.value"
  >
    {{ snackbar.message.value }}
  </VSnackbar>
</template>
